import React, { useState, useEffect } from "react";
import localforage from "localforage";
import "../css/welcomepage.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCab, faTrainSubway } from "@fortawesome/free-solid-svg-icons";
import Dashboard from "./Dashboard";

// Groups the Cab and Travel sections under one "Logistics" entry point.
const Logistics = () => {
  const [userName, setUserName] = useState("");
  const [role, setRole] = useState("");

  useEffect(() => {
    localforage.getItem("userName").then((name) => setUserName(name || ""));
    localforage.getItem("role").then((r) => setRole(r || ""));
  }, []);

  return (
    <>
      <Dashboard />
      <div className="main-welcome">
        <h1 className="header">Welcome, {userName}!</h1>
      </div>
      <div className="buttons-container">
        <h2 className="head-text-welcome">Logistics</h2>
        <div className="buttons">
          {role === "hr" ? null : (
            <a href="/travel-section" className="menu-buttons">
              <FontAwesomeIcon
                icon={faTrainSubway}
                className="font-pdf"
                size="3x"
              />
              Travel Section
            </a>
          )}
          {role === "hr" ? null : (
            <a href="/cab-section" className="menu-buttons">
              <FontAwesomeIcon icon={faCab} className="font-pdf" size="3x" />
              Cab Section
            </a>
          )}
        </div>
      </div>
    </>
  );
};

export default Logistics;
